import { LowerCasePipe } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DialogContentComponentBase, DialogContentViewModel } from '../../dialog/dialog-content-base';
import { DialogContentComponentIns } from '../../dialog/dialog-content-ins.component';
import { DialogHeaderComponentIns } from '../../dialog/dialog-header-ins.component';

export interface CompactViewDialogComponentData {
    items: {
        label: string;
        value: string;
    }[];
    title: string;
}

@Component({
    selector: 'skl-compact-view-details-dialog',
    templateUrl: './compact-view-details-dialog.component.html',
    styleUrls: ['./compact-view-details-dialog.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [DialogContentComponentIns, DialogHeaderComponentIns, LowerCasePipe]
})

export class CompactViewDialogComponent extends DialogContentComponentBase<DialogContentViewModel, CompactViewDialogComponentData> {}
